import { removeSidebar } from "../../../Sidebar/actionCreators"
import { storeTerms, acceptTerms } from "./actionCreators"

export const mapState = (state) => ({
  tcTerms: state.sessionReducer.tcTerms,
  tcManager: state.sessionReducer.tcManager,
})

export const mapDispatch = (dispatch) => ({
  removeSidebar: () => dispatch(removeSidebar()),
  storeTerms: (...data) => dispatch(storeTerms(...data)),
  acceptTerms: (data) => dispatch(acceptTerms(data)),
})
